import type { Payment, QuoteDocument } from 'paintscout'

/**
 * Whether a pending payment request still has something to collect — its amount fits within
 * the quote's current balance due. False for a stale/superseded request (e.g. a separate
 * payment already covered the balance), which should no longer be shown as actionable.
 */
export function isValidPaymentRequest(args: { quote: QuoteDocument; payment: Payment }): boolean {
  const { quote, payment } = args
  if (payment.status !== 'pending') return false
  return payment.amount <= (quote?.totals?.balance_due ?? 0)
}
